export default "__VITE_ASSET__28740130__"